
export default ['FlowValidationService', function (FlowValidationService) {
    this.dismiss = () => {
        FlowValidationService.acknowledgeWarning(this.error.id);
    };
    this.$onInit = () => {
        this.isError = this.error.level === 'LEVEL_ERROR';
    };
}];
